import {loadSearchTableHtmlAsPromise} from "../loadSearchTableHtmlAsPromise/loadSearchTableHtmlAsPromise";
import {UserInterfaceHtmlElements} from "../UserInterfaceHtmlElements/UserInterfaceHtmlElements";
import {SearchWhispererHtmlElement} from "../SearchWhisperer/SearchWhispererHtmlElement";


export function runSearch(
    userInterface: UserInterfaceHtmlElements,
    searchWhisperer: SearchWhispererHtmlElement,
    domain: string
): void {
    // Run search.
    userInterface.isSearchRunning = true;
    userInterface.showSpinnerIcon();
    searchWhisperer.hideSuggestions();
    const promiseOfSearchedCamerasTableHTml = loadSearchTableHtmlAsPromise(
        userInterface.getSearchQuery(),
        domain
    );
    userInterface.swapCamerasTableForSearchResultCamerasTable(promiseOfSearchedCamerasTableHTml);
}